import {getRoundsJsonSuccess} from "modules/actions/rounds";
import {createReducer} from "redux-act";

export const rounds = createReducer<ReturnType<typeof getRoundsJsonSuccess>["payload"]>({}, []);
rounds.on(getRoundsJsonSuccess, (state, payload) => payload);
